import React, {PropTypes} from 'react';
import classNames from 'classnames';
import moment from 'moment';
import BundlingPurchaseGuide from 'shared/BundlingPurchaseGuide.jsx';
import {formatCurrency} from 'shared/util/formatCurrency';
import DisplayIf from 'shared/DisplayIf.jsx';
Number.prototype.formatCurrency = formatCurrency;

const ScheduleSquadListItem = ({
  id,
  startDateTime,
  eventPrice,
  eventTotalPrice,
  available,
  adminAvailable,
  hideFromCaptains,
  quantity,
  countInCart,
  eventAddOnFees,
  showBundleGuide,
  onAddClick,
  onFeesClick,
  onQuantityChange,
  onNextDateClick
}) => (
  <div className="list-group-item-labeled">
    <DisplayIf condition={moment.parseZone(startDateTime).second() === 10 && adminAvailable}>
      <div className="list-group-item-labeled-child"
        style={{width: 80, color: 'red'}}>
        <span>{'Time'}</span>
        <span>{moment.parseZone(startDateTime).format('hh:mm A')}</span>
      </div>
    </DisplayIf>
    <DisplayIf condition={moment.parseZone(startDateTime).second() === 0 || !adminAvailable}>
      <div className="list-group-item-labeled-child"
        style={{width: 80}}>
        <span>{'Time'}</span>
        <span>{moment.parseZone(startDateTime).format('hh:mm A')}</span>
      </div>
    </DisplayIf>
    <div className={classNames(
        {'list-group-item-labeled-child': !eventAddOnFees.length},
        {'list-group-item-labeled-child-clickable': eventAddOnFees.length}
      )}
      style={{width: 80}}
      onClick={eventAddOnFees.length
        ? () => onFeesClick(eventPrice, eventAddOnFees)
        : () => {}}>
      <span>{'Price ($)'}</span>
      <span>{eventTotalPrice.formatCurrency(2)}</span>
    </div>
    <div className="list-group-item-labeled-child"
      style={{width: 80}}>
      <span>{'Available'}
          {(function() { 
            let extraAdminAvailability = available !== (adminAvailable || available);

            return hideFromCaptains || extraAdminAvailability; 
          })()  ? 
            <span className="glyphicon glyphicon-exclamation-sign"
            title={`${(hideFromCaptains ? "Hidden from captains - " : "") + adminAvailable  } available for Admins to reserve`}
            style={{marginLeft: 5, color: '#fb9838'}}/>
            :
            null
          }
      </span>
      <span>{available > 0 ? available: 0}</span>
    </div>
    <div className="list-group-item-labeled-child"
      style={{width: 80}}>
      <span>{'Quantity'}</span>
      <input
        style={{width: 80}}
        disabled={!available && !adminAvailable}
        type="number"
        min="0"
        step="1"
        max={adminAvailable ? adminAvailable : available}
        value={quantity}
        onChange={event => onQuantityChange({
          squadId: id,
          inputValue: event.target.value,
          max: adminAvailable ? adminAvailable : available
        })}
      />
    </div>
    <div className="list-group-item-labeled-child"
      style={{width: 100, marginTop: 8}}>
      {
        (adminAvailable? adminAvailable > 0 : available > 0)
        ? <button
            className={quantity > 0 ? 'btn btn-warning' : 'btn btn-link'}
            type="button"
            disabled={!quantity}
            onClick={() => onAddClick(id, quantity)}
          ><i className="fa fa-shopping-cart" /> { quantity > 0 ? `Add (${quantity})` : 'Add'}</button>
        : <span className="label label-danger">{`SOLD OUT`}</span>
      }
    </div>
    <div className="list-group-item-labeled-child"
      style={{width: 50}}>
      <span>{'In Cart'}</span>
      <span>{countInCart}</span>
    </div>
    <BundlingPurchaseGuide
      visible={showBundleGuide}
      nextDate={moment.parseZone(startDateTime).add(1, 'days')}
      onNextDateClick={onNextDateClick}
    />
  </div>
);

ScheduleSquadListItem.propTypes = {
  id: PropTypes.string.isRequired,
  startDateTime: PropTypes.string.isRequired,
  eventPrice: PropTypes.number,
  eventTotalPrice: PropTypes.number,
  available: PropTypes.number,
  adminAvailable: PropTypes.number,
  hideFromCaptains: PropTypes.bool,
  quantity: PropTypes.number,
  countInCart: PropTypes.number,
  eventAddOnFees: PropTypes.arrayOf(PropTypes.object),
  showBundleGuide: PropTypes.bool,
  onFeesClick: PropTypes.func,
  onAddClick: PropTypes.func,
  onQuantityChange: PropTypes.func,
  onNextDateClick: PropTypes.func
};

ScheduleSquadListItem.defaultProps = {
  eventAddOnFees: [],
  quantity: 0,
  eventTotalPrice: 0,
  countInCart: 0,
  showBundleGuide: false
};

export default ScheduleSquadListItem;



// WEBPACK FOOTER //
// ./src/features/shared/ScheduleSquadListItem.jsx